import { Level2Wrapper } from '../common/Level2Wrapper';
import { ImageList } from '../common/ImageList';
import { GenericSubSection } from '../common/GenericSubSection';
import { useDashSection } from '../../hooks/useDashSection';

export const Dash = () => {
  const { section, images } = useDashSection();

  return (
    <Level2Wrapper flex="1 1 100%" label="Dash">
      <ImageList label="Dash Pictures" images={images} />
      {Object.values(section?.subsections ?? {}).map(sub => (
        <GenericSubSection key={sub.id} section={sub} />
      ))}
    </Level2Wrapper>
  );
};
